import { DiscountsType } from './EditDiscountModal';

export const validateDiscountValue = (
  discount: string,
  discountType: DiscountsType,
  t: (key: string) => string,
  grossPrice?: string | null
): string | undefined => {
  const value = Number(discount);

  if (discount === '') return undefined;

  if (discountType === DiscountsType.PERCENTAGE) {
    if (value < 0 || value > 100) {
      return t('Percentage must be between 0 and 100');
    }
  }

  if (
    discountType === DiscountsType.AMOUNT &&
    grossPrice !== undefined &&
    grossPrice !== null &&
    grossPrice !== ''
  ) {
    const gross = Number(grossPrice);

    if (gross === 0 && value !== 0) {
      return t('Discount must be 0 when gross price is 0');
    }

    // if (Math.abs(value) > Math.abs(gross)) {
    //   return t('Discount cannot be greater than gross price');
    // }

    // if (Math.sign(value) !== Math.sign(gross)) {
    //   return t('Discount must have the same sign as gross price');
    // }
  }

  return undefined;
};
